<template>
  <footer class="py-4 dark-section">
    <div class="container">
      <div class="row">
        <!--        <div class="col-md-6 text-md-start text-center mb-4 mb-md-0">-->
        <!--          <div class="contact-info">-->
        <!--&lt;!&ndash;            <p>&ndash;&gt;-->
        <!--&lt;!&ndash;              <i class="fas fa-map-marker-alt"></i> Neustr. 64, 41836 Hückelhoven&ndash;&gt;-->
        <!--&lt;!&ndash;            </p>&ndash;&gt;-->
        <!--            <p>-->
        <!--              <i class="fas fa-envelope"></i>-->
        <!--              <a href="mailto:info@crafting-systems.de" class="custom-link">-->
        <!--                info@crafting-systems.de-->
        <!--              </a>-->
        <!--            </p>-->
        <!--            <p>-->
        <!--              <i class="fas fa-phone"></i>-->
        <!--              <a href="tel:+4915162987881" class="custom-link">-->
        <!--                +49 151 629 878 81-->
        <!--              </a>-->
        <!--            </p>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="row align-items-center">
          <div class="col-md-6 text-md-start">
            <p class="mb-0">&copy; 2025 Crafting Systems GmbH. Alle Rechte vorbehalten.</p>
          </div>
          <div class="col-md-3 justify-content-end social-icons">
            <a href="https://www.linkedin.com/company/100260640/" target="_blank" class="social-link">
              <i class="fab fa-linkedin"></i>
            </a>
<!--            <a href="https://github.com/Crafting-Systems" target="_blank" class="social-link">-->
<!--              <i class="fab fa-github"></i>-->
<!--            </a>-->
          </div>
          <div class="col-md-3 legal-info align-items-center">
            <div class="icon-link">
              <i class="fas fa-gavel icon"></i>
              <router-link to="/impressum" class="label">Impressum</router-link>
            </div>
            <div class="icon-link">
              <i class="fas fa-shield-alt icon"></i>
              <router-link to="/datenschutz" class="label">Datenschutz</router-link>
            </div>
            <!--<p class="legal-item">
              <router-link to="/contact" class="custom-link">Kontakt</router-link>
              <i class="fas fa-envelope"></i>
            </p>-->
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>

<script lang="ts">
export default {
  name: 'SiteFooter',
};
</script>

<style scoped lang="less">
@import '@/assets/style.less';

.social-icons {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.legal-info {
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  footer .col-md-6 {
    text-align: center;
    margin-bottom: 1rem;
  }

  .legal-info {
    justify-content: center;
    align-items: center;
  }

  .social-icons {
    justify-content: center !important;
    margin-bottom: 1rem;
  }
}
</style>
